module.exports = __webpack_public_path__ + "static/RagaPartners_billboard-bb7b2521c1696864bfe22e035b204e41.png";